import {CorporateList} from "./CorporateList";
import {CorporateEdit} from "./CorporateEdit";
import {CorporateCreate} from "./CorporateCreate";

export default {
    list: CorporateList,
    create: CorporateCreate,
    edit: CorporateEdit
};
